// Core Modules
import React from 'react';
import {Link} from 'react-router-dom';
// Dependancy Modules
import HashLoader from "react-spinners/HashLoader";

const ExamsList = (props) => {
    let rows = props.data.map(el => {
        return <tr key={el.key}>
                    <td>
                        {getSubject(el.subject)}
                    </td>
                    <td>{el.title}</td>
                    <td>
                        {new Date(Number(el.initialTime)).toLocaleString()}
                    </td>
                    <td>
                        {new Date(Number(el.finalTime)).toLocaleString()}
                    </td>
                    <td>
                        <Link 
                            type="button" 
                            rel="tooltip" 
                            title="view"
                            className="btn btn-success btn-sm"
                            to={`/exams/${el.key}`}>
                                <i className="material-icons">remove_red_eye</i>
                        </Link>
                    </td>
               </tr>
    });
    return ( 
        <div className="card">
            <div className="card-header card-header-primary" style={{background: 'linear-gradient(60deg, #262222, #222222)'}}>
                <h4 className="card-title" style={{fontSize: '1.3rem', fontWeight: 'bolder'}}>Exams</h4>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    {
                        props.loading ? 
                            <HashLoader
                                css={{display: 'block', margin: '10px auto 10px', width: '100%', borderColor: 'red'}}
                                size={40}
                                color={"#262222"}
                                loading={props.loading} />
                        :
                            <table className="table table-hover">
                                <thead style={{color: '#262222'}}>
                                    <tr>
                                        <th>Subject</th>
                                        <th>Name</th>
                                        <th>Starting Time</th>
                                        <th>Ending Time</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { 
                                        props.data.length !== 0 ?
                                            rows
                                        :
                                            <tr><td colSpan="5"><h1 style={{fontSize: '20px', textAlign: "center"}}>No Exams Yet</h1></td></tr>
                                    }
                                </tbody>
                            </table>
                    }
                </div>
            </div>
        </div>
    );
}

const getSubject = (subCode) => {
    if (subCode === "phy") {
        return "Physics";        
    } else if (subCode === "che") {
        return "Chemistry";
    } else if (subCode === "mat") {
        return "Maths";
    } else if (subCode === "bot") {
        return "Botany";
    } else if (subCode === "zoo") {
        return "Zoology";
    } else if (subCode === "bio") {
        return "Biology";
    } else if (subCode === "hin") {
        return "Hindi";
    } else if (subCode === "eng") {
        return "English";
    } else if (subCode === "soc") {
        return "Social Science";
    }
    return "";
}
 
export default ExamsList;